import { ICellRendererParams } from 'ag-grid-community';
import { FunctionComponent } from 'react';
import { TransactionModel } from '../../types/TransactionModel';
import { TransactionStatus } from '../../api/transactions/transaction.contracts';
import { useTranslation } from '@/lib';

export const GuestTransactionStatusCellRenderer: FunctionComponent<ICellRendererParams<TransactionModel>> = (params) => {
  const { t } = useTranslation();

  if (!params.data) {
    return null;
  }

  const status = params.data.status;

  // Get label based on status
  const getStatusLabel = (statusValue: TransactionStatus) => {
    switch (statusValue) {
      case TransactionStatus.InProgress:
        return t('in_progress');
      case TransactionStatus.Finalized:
        return t('finalized');
      default:
        return t('unknown');
    }
  };

  // Get color classes based on status
  const getColorClasses = (statusValue: TransactionStatus) => {
    switch (statusValue) {
      case TransactionStatus.InProgress:
        return {
          bg: 'bg-yellow-100 dark:bg-yellow-500/20',
          text: 'text-yellow-800 dark:text-yellow-300',
        };
      case TransactionStatus.Finalized:
        return {
          bg: 'bg-green-100 dark:bg-green-500/20',
          text: 'text-green-800 dark:text-green-300',
        };
      default:
        return {
          bg: 'bg-gray-100 dark:bg-gray-500/20',
          text: 'text-gray-800 dark:text-gray-300',
        };
    }
  };

  const colors = getColorClasses(status);

  return (
    <div className="flex h-full items-center">
      <div className="inline-flex mt-1">
        <span
          className={`inline-flex items-center gap-1 px-3 py-1 text-xs font-semibold ${colors.bg} ${colors.text} rounded-md`}
        >
          {getStatusLabel(status)}
        </span>
      </div>
    </div>
  );
};
